var _path, _path2, _path3, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterBgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 370 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.155 319.148H-39.4731C-39.4731 319.148 -21.0108 298.428 42.1533 299.311C117.952 300.191 128.155 319.148 128.155 319.148Z",
    fill: "#D1D048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.457 317.634H-55C-55 317.634 -46.0382 306.426 -15.5181 308.08C15.0041 309.734 22.0053 311.753 22.0053 311.753C22.0053 311.753 23.4052 298.893 46.9261 297.608C70.4471 296.321 81.9282 303.487 81.9282 303.487C81.9282 303.487 78.007 290.075 108.529 282.175C139.049 274.275 160.051 285.85 165.092 293.014C165.092 293.014 177.131 280.888 196.172 286.401C215.214 291.912 214.653 304.772 214.653 304.772C214.653 304.772 238.176 298.527 262.816 297.608C287.737 296.689 289.417 317.266 289.417 317.266L252.457 317.634Z",
    fill: "#D1D048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M147.674 319.045C145.509 312.913 146.294 299.431 166.758 294.566C178.852 291.692 186.294 293.213 190.569 295.861C184.18 286.506 179.978 273.553 195.384 268.84C199.377 266.969 211.666 264.069 228.882 267.437C222.115 256.835 215.28 233.666 242.079 225.807C268.877 217.949 289.924 227.003 297.097 232.512C298.18 224.872 306.68 211.214 332.017 217.7C354.146 221.754 368.763 229.082 369.169 237.657V318.989L147.674 319.045Z",
    fill: "#D1D048"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2456_5861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -3,
    y: 0,
    width: 166,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 0.414062,
    width: 166,
    height: 148.657,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2456_5861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.965 134.825C109.353 129.406 108.85 117.493 95.7362 113.194C87.9864 110.654 83.2172 111.998 80.478 114.338C84.5721 106.072 87.2646 94.6259 77.3926 90.4618C74.834 88.8085 66.9588 86.246 55.9266 89.2219C60.2632 79.8533 64.6431 59.3803 47.4704 52.4365C30.2976 45.4927 16.811 53.4928 12.2142 58.3607C11.5204 51.6099 6.07368 39.541 -10.1624 45.2723C-24.3429 48.8544 -33.7098 55.3297 -33.97 62.9073V134.775L107.965 134.825Z",
    fill: "#D1D048"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBgB);
export default __webpack_public_path__ + "static/media/footer-bg-b.53df751928603089f83d5125a83dd95d.svg";
export { ForwardRef as ReactComponent };